"use client";
import { PageLayout } from "@hubble/web";
import React from "react";
import { CustomContainer } from "./CoinPriceChart/style";

interface PageLayoutIslandProps {
  header: React.ReactNode;
  content: React.ReactNode;
  sidePanel: React.ReactNode;
}

// page layout depends on displayName which apparently is a client side property
// pass in server components to this client component for now to maximize server capability
export const PageLayoutIsland = ({
  header,
  content,
  sidePanel
}: PageLayoutIslandProps) => {
  return (
    <React.Fragment>
      <CustomContainer>
        <PageLayout>
          <PageLayout.Content>{header}</PageLayout.Content>
        </PageLayout>
      </CustomContainer>
      <CustomContainer>
        <PageLayout>
          <PageLayout.Content>{content}</PageLayout.Content>
          <PageLayout.SidePanel>{sidePanel}</PageLayout.SidePanel>
        </PageLayout>
      </CustomContainer>
    </React.Fragment>
  );
};
